import React, { useState, useEffect } from "react";
import * as Sentry from '@sentry/browser';
import Api from "../../Api";
import classes from "./styles.module.css";

/**
 * MerchantSettingsFeesTab — комиссии на уровне MerchantSettings.
 *
 * Отдельно от Terminal fees. MS fees — это комиссия для конкретного мерчанта,
 * Terminal fees — для провайдера.
 *
 * Props:
 *   token (string)
 *   terminal (object) — { id, projectUuid, ... }
 */
function MerchantSettingsFeesTab(props) {
    var token = props.token;
    var terminal = props.terminal;

    var _msList = useState([]);
    var msList = _msList[0];
    var setMsList = _msList[1];

    var _selectedMsId = useState(null);
    var selectedMsId = _selectedMsId[0];
    var setSelectedMsId = _selectedMsId[1];

    var _payment = useState({ cost: "", fixedPerTransaction: "", costFixedMinimum: "" });
    var payment = _payment[0];
    var setPayment = _payment[1];

    var _payout = useState({ cost: "", fixedPerTransaction: "", costFixedMinimum: "" });
    var payout = _payout[0];
    var setPayout = _payout[1];

    var _refund = useState({ cost: "", fixedPerTransaction: "", costFixedMinimum: "" });
    var refund = _refund[0];
    var setRefund = _refund[1];

    var _saving = useState(false);
    var saving = _saving[0];
    var setSaving = _saving[1];

    var _loading = useState(true);
    var loading = _loading[0];
    var setLoading = _loading[1];

    var _status = useState(null);
    var status = _status[0];
    var setStatus = _status[1];

    // Загрузить MS список через /merchant/{uuid}/full
    useEffect(function () {
        if (!terminal || !terminal.id || !terminal.projectUuid) return;
        setLoading(true);
        setStatus(null);

        var api = new Api({ token: token });
        api.getFullMerchant(terminal.projectUuid).then(function (data) {
            var settings = (data && data.settings) || [];
            // Фильтруем только MS привязанные к этому терминалу
            var filtered = settings.filter(function (s) {
                return s.terminalId === terminal.id;
            });
            setMsList(filtered);

            if (filtered.length > 0) {
                setSelectedMsId(filtered[0].id);
                loadFeesFromMs(filtered[0]);
            }
            setLoading(false);
        }).catch(function (err) {
            Sentry.captureException(err);
            setLoading(false);
            setStatus({ type: "error", text: "\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A" });
        });
    }, [terminal && terminal.id, terminal && terminal.projectUuid, token]);

    function loadFeesFromMs(ms) {
        var fee = ms.fee || {};
        setPayment({
            cost: String(fee.payment && fee.payment.cost != null ? fee.payment.cost : ""),
            fixedPerTransaction: String(fee.payment && fee.payment.fixedPerTransaction != null ? fee.payment.fixedPerTransaction : ""),
            costFixedMinimum: String(fee.payment && fee.payment.costFixedMinimum != null ? fee.payment.costFixedMinimum : ""),
        });
        setPayout({
            cost: String(fee.payout && fee.payout.cost != null ? fee.payout.cost : ""),
            fixedPerTransaction: String(fee.payout && fee.payout.fixedPerTransaction != null ? fee.payout.fixedPerTransaction : ""),
            costFixedMinimum: String(fee.payout && fee.payout.costFixedMinimum != null ? fee.payout.costFixedMinimum : ""),
        });
        setRefund({
            cost: String(fee.refund && fee.refund.cost != null ? fee.refund.cost : ""),
            fixedPerTransaction: String(fee.refund && fee.refund.fixedPerTransaction != null ? fee.refund.fixedPerTransaction : ""),
            costFixedMinimum: String(fee.refund && fee.refund.costFixedMinimum != null ? fee.refund.costFixedMinimum : ""),
        });
    }

    function onMsChange(e) {
        var id = parseInt(e.target.value, 10);
        setSelectedMsId(id);
        setStatus(null);
        var ms = msList.find(function (s) { return s.id === id; });
        if (ms) loadFeesFromMs(ms);
    }

    function onFieldChange(group, field, value) {
        if (value !== "" && !/^\d*\.?\d*$/.test(value)) return;

        if (group === "payment") {
            var next = {};
            for (var k in payment) { next[k] = payment[k]; }
            next[field] = value;
            setPayment(next);
        } else if (group === "payout") {
            var next2 = {};
            for (var k2 in payout) { next2[k2] = payout[k2]; }
            next2[field] = value;
            setPayout(next2);
        } else if (group === "refund") {
            var next3 = {};
            for (var k3 in refund) { next3[k3] = refund[k3]; }
            next3[field] = value;
            setRefund(next3);
        }
    }

    function onSave() {
        if (!selectedMsId || !terminal.projectUuid) return;
        setSaving(true);
        setStatus(null);

        var fee = {
            payment: {
                cost: payment.cost !== "" ? parseFloat(payment.cost) : 0,
                fixedPerTransaction: payment.fixedPerTransaction !== "" ? parseFloat(payment.fixedPerTransaction) : 0,
                costFixedMinimum: payment.costFixedMinimum !== "" ? parseFloat(payment.costFixedMinimum) : 0,
            },
            payout: {
                cost: payout.cost !== "" ? parseFloat(payout.cost) : 0,
                fixedPerTransaction: payout.fixedPerTransaction !== "" ? parseFloat(payout.fixedPerTransaction) : 0,
                costFixedMinimum: payout.costFixedMinimum !== "" ? parseFloat(payout.costFixedMinimum) : 0,
            },
            refund: {
                cost: refund.cost !== "" ? parseFloat(refund.cost) : 0,
                fixedPerTransaction: refund.fixedPerTransaction !== "" ? parseFloat(refund.fixedPerTransaction) : 0,
                costFixedMinimum: refund.costFixedMinimum !== "" ? parseFloat(refund.costFixedMinimum) : 0,
            },
        };

        var api = new Api({ token: token });
        api.updateMerchantSetting(terminal.projectUuid, selectedMsId, { fee: fee }).then(function () {
            setSaving(false);
            setStatus({ type: "success", text: "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u0438 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u044B" });
            // Обновить локальный список
            setMsList(function (prev) {
                return prev.map(function (ms) {
                    if (ms.id === selectedMsId) {
                        return Object.assign({}, ms, { fee: fee });
                    }
                    return ms;
                });
            });
        }).catch(function (err) {
            Sentry.captureException(err);
            setSaving(false);
            var msg = (err && err.response && err.response.data && err.response.data.message) || "\u041E\u0448\u0438\u0431\u043A\u0430 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F";
            setStatus({ type: "error", text: msg });
        });
    }

    function renderFeeGroup(title, operations, group, state) {
        return React.createElement("div", { className: classes.FeeGroup },
            React.createElement("div", { className: classes.FeeGroupTitle }, title),
            React.createElement("div", { className: classes.FeeGroupDescription }, operations),
            React.createElement("div", { className: classes.FieldRow },
                React.createElement("div", { className: classes.Field },
                    React.createElement("div", { className: classes.FieldLabel }, "\u041F\u0440\u043E\u0446\u0435\u043D\u0442 (%)"),
                    React.createElement("input", {
                        className: classes.FieldInput,
                        type: "text",
                        value: state.cost,
                        onChange: function (e) { onFieldChange(group, "cost", e.target.value); },
                        placeholder: "0",
                    })
                ),
                React.createElement("div", { className: classes.Field },
                    React.createElement("div", { className: classes.FieldLabel }, "\u0424\u0438\u043A\u0441. \u0437\u0430 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044E (\u0440\u0443\u0431)"),
                    React.createElement("input", {
                        className: classes.FieldInput,
                        type: "text",
                        value: state.fixedPerTransaction,
                        onChange: function (e) { onFieldChange(group, "fixedPerTransaction", e.target.value); },
                        placeholder: "0",
                    })
                ),
                React.createElement("div", { className: classes.Field },
                    React.createElement("div", { className: classes.FieldLabel }, "\u041C\u0438\u043D. \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u044F (\u0440\u0443\u0431)"),
                    React.createElement("input", {
                        className: classes.FieldInput,
                        type: "text",
                        value: state.costFixedMinimum,
                        onChange: function (e) { onFieldChange(group, "costFixedMinimum", e.target.value); },
                        placeholder: "0",
                    })
                )
            )
        );
    }

    if (loading) {
        return React.createElement("div", { className: classes.Container }, "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...");
    }

    if (msList.length === 0) {
        return React.createElement("div", { className: classes.Container },
            React.createElement("div", { className: classes.Title }, "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u0438 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430"),
            React.createElement("div", { className: classes.Empty }, "\u041D\u0435\u0442 \u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430 \u0434\u043B\u044F \u044D\u0442\u043E\u0433\u043E \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0430")
        );
    }

    return React.createElement("div", { className: classes.Container },
        React.createElement("div", { className: classes.Title }, "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u0438 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430 (MerchantSettings)"),

        msList.length > 1 && React.createElement("div", { className: classes.MsSelector },
            React.createElement("div", { className: classes.MsLabel }, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0443:"),
            React.createElement("select", { value: selectedMsId || "", onChange: onMsChange },
                msList.map(function (ms) {
                    return React.createElement("option", { key: ms.id, value: ms.id },
                        "MS #" + ms.id + " \u2014 " + (ms.providerName || "?") + " (" + (ms.currency && ms.currency.code || "RUB") + ")"
                    );
                })
            )
        ),

        renderFeeGroup(
            "\u041E\u043F\u043B\u0430\u0442\u0430 (Payment)",
            "Purchase, Recurrent, SBP, P2P, QR",
            "payment",
            payment
        ),
        renderFeeGroup(
            "\u0412\u044B\u043F\u043B\u0430\u0442\u044B (Payout)",
            "Payout, Mobile Payout",
            "payout",
            payout
        ),
        renderFeeGroup(
            "\u0412\u043E\u0437\u0432\u0440\u0430\u0442\u044B (Refund)",
            "Refund",
            "refund",
            refund
        ),

        React.createElement("div", { style: { marginTop: "10px", padding: "8px", background: "#fff3e0", borderRadius: "4px", fontSize: "12px", color: "#e65100" } },
            "\u042D\u0442\u043E \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u0438 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430 (MerchantSettings). \u041E\u043D\u0438 \u043C\u043E\u0433\u0443\u0442 \u043E\u0442\u043B\u0438\u0447\u0430\u0442\u044C\u0441\u044F \u043E\u0442 \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u0439 \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0430 (Terminal fees)."
        ),

        React.createElement("button", {
            className: classes.SaveBtn,
            onClick: onSave,
            disabled: saving,
        }, saving ? "\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435..." : "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C"),

        status && React.createElement("div", {
            className: classes.StatusMsg + " " + (status.type === "success" ? classes.StatusSuccess : classes.StatusError),
        }, status.text)
    );
}

export default MerchantSettingsFeesTab;



// WEBPACK FOOTER //
// ./src/Components/MerchantSettingsFeesTab/index.js